export const initialCreateFasceData = {
  data: {
    destinationTypes: [],
    fdnList: [],
    fdnGroupList: [],
    vocalMessagesList: [],
    odrList: [],
    tdrList: [],
    barringList: [],
    messagiVocaliSuBaseOrigineList: [],
    whiteList: [],
    menuServiceList: [],
    nedList: [],
    currentItemList: [],
  },
  loading: false,
};

export const initialSelectedFasce = {
  data: {
    dayPlanId: "",
    dayPlanName: "",
    dayPlanObjectList: [],
  },
  loading: false,
};
